import SimpleAutocompleteFactory from "components/Autocomplete/SimpleAutocompleteFactory"
import { TransactionFilterFeeTypeValueEnum } from "services/api/openapi"

export const FeeTypeFilter = SimpleAutocompleteFactory<TransactionFilterFeeTypeValueEnum>({
  transactionWithFee: "Transactions with fees",
  feeOnlyTransaction: "Fee only transactions",
})

export default FeeTypeFilter
